"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForDomUpdate = void 0;
// Dom is usually updated on next tick, 4ms standard timeout
const DOM_UPDATE_DELAY = 4;
const waitForDomUpdate = () => new Promise((resolve) => setTimeout(resolve, DOM_UPDATE_DELAY));
exports.waitForDomUpdate = waitForDomUpdate;
//# sourceMappingURL=dom-update-delay.js.map